<template>
  <div>
    <v-container>
      <v-row>
        <v-btn class="mb-2" fab to="/">
          <v-icon dark>mdi-arrow-left-thick</v-icon>
        </v-btn>
      </v-row>
      <v-row>
        <v-col>
          <v-card>
            <v-card-title class="blue">
              <v-container>
                <v-row>
                  <v-expansion-panels tile flat class="mt-n2">
                    <v-expansion-panel style="background: #2196f3">
                      <v-expansion-panel-header>
                        <div class="text-h6 ml-n6">
                          {{ $t("Ordre") }} {{ ordre.albara }}
                          <br />
                          {{ ordre.nom }} ({{ ordre.client }})
                        </div>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <div class="text-subtitle-1">
                          <span class="font-weight-bold">{{
                            $t("Adreca")
                          }}</span>
                          {{ ordre.domicili }}
                        </div>
                        <div class="text-subtitle-1">
                          <span class="font-weight-bold">{{
                            $t("Poblacio")
                          }}</span>
                          {{ ordre.poblacio }}
                        </div>
                        <div class="text-subtitle-1">
                          <span class="font-weight-bold">{{
                            $t("Telefon")
                          }}</span>
                          {{ ordre.telefon }}
                        </div>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-row>
              </v-container>
            </v-card-title>
            <v-card-text>
              <h3 class="mt-2">{{ $t("Feines_a_fer") }}</h3>
              <v-form>
                <v-textarea v-if="
                  ordre.observacionsOrdre != null &&
                  ordre.observacionsOrdre.trim() != ''
                " auto-grow rows="1" readonly :value="ordre.observacionsOrdre" hide-details="auto"></v-textarea>
                <v-text-field v-if="
                  ordre.descripcio != null && ordre.descripcio.trim() != ''
                " readonly :value="ordre.descripcio" hide-details="auto"></v-text-field>
                <v-textarea v-if="
                  ordre.observacionsSubordre != null &&
                  ordre.observacionsSubordre.trim() != ''
                " auto-grow rows="1" readonly :value="ordre.observacionsSubordre" hide-details="auto"></v-textarea>
              </v-form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-container>
      <!-- <v-row justify="center" class="mt-5 mb-5">
        <v-btn @click="ferFoto()">{{ $t("IncorporarFotosOrdre") }}</v-btn>
      </v-row> -->
      <v-row justify="center" class="mt-5 mb-5">
        <v-btn @click="firmar()">{{ $t("FirmarOrdre") }}</v-btn>
      </v-row>
      <v-row>
        <h2 class="ml-3 mt-4 mb-2">{{ $t("Petit_material") }}</h2>
      </v-row>
      <v-row v-for="(item, index) in articles" :key="index" class="mb-1">
        <v-col>
          <v-card>
            <v-card-title class="grey lighten-3">
              <v-container fluid>
                <v-row align="center">
                  <v-checkbox v-model="checkbox[index]" @click="click(index)"></v-checkbox>
                  <span class="text-body-1 font-weight-bold" @click="select(index)">{{ item.descripcio }}</span>
                </v-row>
              </v-container>
            </v-card-title>
            <v-card-text v-if="checkbox[index]">
              <v-form :ref="'form_' + index">
                <v-text-field :label="$t('Quantitat')" v-model="quantitat[index]" type="number"
                  :rules="[(v) => !!v || $t('Requerit')]"></v-text-field></v-form>
              <!-- Alerta per falta d'estoc -->
              <v-alert v-model="senseEstoc[index]" type="error" class="mt-2">
                {{ $t("senseEstoc") }}
              </v-alert>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="ml-0 mt-4 mb-4">
        <v-btn @click="afegirArticle()">
          {{ $t("AfegirArticles") }}
        </v-btn>
      </v-row>
      <v-row class="ml-0 mt-4">
        <v-btn class="" to="/">
          {{ $t("Cancelar") }}
        </v-btn>
        <v-btn class="ml-2" color="green" @click="send()">
          {{ $t("Acceptar") }}
        </v-btn>
      </v-row>

      <v-row>
        <v-btn class="mt-6" fab to="/">
          <v-icon dark>mdi-arrow-left-thick</v-icon>
        </v-btn>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import api from "../api.js";

export default {
  data: () => ({
    articles: [],
    checkbox: [],
    quantitat: [],
    ordre: null,
    senseEstoc: [],
  }),
  created() {
    var or = localStorage.getItem("systimes.ordre" + api.getEmp());
    if (or != null && or != "") this.ordre = JSON.parse(or);
    // this.requerit = this.$t("Requerit");

    var articles = localStorage.getItem("systimes.material" + api.getEmp());
    if (articles != null && articles != "") {
      this.articles = JSON.parse(articles);

      // si triat comprovar estoc
      this.articles.forEach((item, index) => {
        if (item.triat) {
          this.checkbox.push(true);
          this.quantitat.push(item.quantitat);
          this.estoc(index, item.id);
        } else {
          this.checkbox.push(false);
          this.quantitat.push("");
          this.senseEstoc.push(false);
        }
      });

      // // Actualitzar checkbox i quantitat
      // this.articles.forEach((item) => {
      //   this.checkbox.push(item.triat);
      //   this.quantitat.push(item.quantitat);
      //   this.senseEstoc.push(false);
      // });

    } else {
      axios.get(api.URL() + "/api/v1/petitMaterialG", api.header()).then((response) => {
        this.articles = response.data;
        // Afegir checkbox i quantitat
        this.articles.forEach(() => {
          this.checkbox.push(false);
          this.quantitat.push("");
          this.senseEstoc.push(false);
        });
      });
    }
  },
  methods: {
    estoc(index, idArticle) {
      axios
        .post(
          api.URL() + "/api/v1/estoc",
          {
            idArticle: idArticle,
            magatzem: this.ordre.magatzem,
          },
          api.header()
        )
        .then((response) => {
          console.log(response.data);
          if (response.data <= 0) {
            this.senseEstoc[index] = true;
          } else {
            this.senseEstoc[index] = false;
          }
          this.$forceUpdate();
        });
    },
    click(index) {
      if (this.checkbox[index]) {
        this.estoc(index, this.articles[index].id);
      } else {
        this.senseEstoc[index] = false;
      }
    },
    select(index) {
      if (!this.checkbox[index]) {
        this.estoc(index, this.articles[index].id);
      }
      this.checkbox[index] = !this.checkbox[index];
      this.$forceUpdate();
    },
    save() {
      var articlesNou = [];
      for (var i = 0; i < this.articles.length; i++) {
        if (this.$refs["form_" + i.toString()])
          if (!this.$refs["form_" + i.toString()][0]?.validate()) {
            return;
          }
        if (this.checkbox[i]) {
          articlesNou.push({
            id: this.articles[i].id,
            descripcio: this.articles[i].descripcio,
            quantitat: this.quantitat[i],
            triat: true,
          });
        } else {
          articlesNou.push({
            id: this.articles[i].id,
            descripcio: this.articles[i].descripcio,
            quantitat: "",
            triat: false,
          });
        }
      }

      localStorage.setItem("systimes.material" + api.getEmp(), JSON.stringify(articlesNou));
    },
    send() {
      this.save();
      this.$router.push("/");
    },
    afegirArticle() {
      this.save();
      this.$router.push("/ArticlesG");
    },
    ferFoto() {
      this.$router.push("/foto");
    },
    firmar() {
      this.$router.push("/firmar");
    },
  },
};
</script>
